module.exports = __webpack_public_path__ + "static/media/C2.db533084.png";